import React from 'react';
import { Icon } from './Icon.js';
export const IconRectLogout = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M10 12H20.9999H20.4999", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M16.9999 16L20.9999 12L16.9999 8.00002", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M20 1V6.75781L18 4.75781V3H6V21H18V19.2422L20 17.2422V23H4V1H20Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconRectLogout.js.map